<template>
  <div class="min-h-screen bg-true-gray-900 text-true-gray-200">
    <div class="max-w-xl mx-auto px-4 py-16 sm:py-24">
      <p class="text-sm font-semibold tracking-wider text-yellow-400 uppercase">MTP Entrance Reviewer</p>
      <h1 class="mt-3 text-3xl font-bold text-true-gray-100">Preparing for MTP?</h1>
      <p class="mt-4 text-base text-true-gray-400">
        The MTP Reviewer just got a major upgrade. Explore the new dedicated app covering the Entrance Exam, Practical Assessment, MANDEX, and Interview.
      </p>
      <button
        type="button"
        @click="openApp"
        class="mt-8 w-full text-center whitespace-nowrap text-base rounded-md bg-yellow-400 py-3 font-semibold text-black hover:bg-yellow-500"
      >
        Explore the New MTP Reviewer
      </button>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase/config";
import { userService } from "@/utils/user";
import { mtpHandoffPath, openMtpApp } from "@/utils/mtpAppLink";

export default {
  methods: {
    async openApp() {
      let status = null;
      const uid = firebase.auth().currentUser && firebase.auth().currentUser.uid;
      if (uid) {
        try {
          const info = await userService.fetchUserData(firebase.firestore(), uid);
          status = info && info.reviewers && info.reviewers.mtp;
        } catch (error) {
          console.error("Error loading MTP status for handoff:", error);
        }
      }
      openMtpApp("mtp_route", mtpHandoffPath(status));
    },
  },
};
</script>
